import type { IconProps } from "@/types/icon";

const BulletPointIcon = ({
    width = 4,
    height = 4,
    fill = "#F2F2F2",
    ...remainingProps
}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 4 4"
        fill="none"
        {...remainingProps}
    >
        <circle cx="2" cy="2" r="2" fill={fill} />
    </svg>
);

export default BulletPointIcon;
